export const APP_MARKET_FEATURE_FLAG = 'rollout.apps.pov_app_market';
export const ANGULAR_APP_MARKET_ROUTE = 'app.app-market';

export const CAN_PURCHASE_PERMISSION = 'can_purchase';

export const PURCHASE_STATE = {
  PURCHASED: 'purchased',
  SUSPENDED: 'suspended',
  CANCELED: 'canceled',
  NOT_PURCHASED: 'not_purchased',
};

export const MARKET_SKELETON_COUNT = {
  DESKTOP: 8,
  MOBILE: 4,
};
